exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.destinations[data-v-5a601896] {\n  display: inline;\n}\n", ""]);

// exports
